exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}.body,.email{color:#161c2d}.email{font-weight:300;font-size:1.5rem;line-height:1.8rem}.header{font-weight:400;font-size:1.8rem;line-height:2.2rem;color:#161c2d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8ec13e1e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ContactLarge.vue
// module id = 41
// module chunks = 0